import { defineComponent as i, useSlots as d, openBlock as r, createBlock as y, unref as a, mergeProps as c, withCtx as f, renderSlot as n, createCommentVNode as s } from "vue";
import m from "./ghl-ui.es242.js";
const B = i({
  name: "UIButton"
}), k = i({
  ...B,
  props: {
    id: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "default"
    },
    size: {
      type: String,
      default: "medium"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    ghost: {
      type: Boolean,
      default: !1
    },
    quaternary: {
      type: Boolean,
      default: !1
    },
    circle: {
      type: Boolean,
      default: !1
    },
    text: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: void 0
    },
    linkGray: {
      type: Boolean
    }
  },
  emits: ["click"],
  setup(e) {
    const o = d();
    return (t, l) => (r(), y(a(m), c({
      id: e.id,
      text: e.text,
      class: [
        e.quaternary ? "quaternary" : null,
        e.circle || e.text ? "icon-only" : null,
        e.active ? "hl-active-btn" : null,
        e.text ? "hl-text-btn" : null,
        e.linkGray ? "hl-linkgray-btn" : null
      ],
      type: e.type,
      size: e.size
    }, t.$attrs, {
      disabled: e.disabled,
      loading: e.loading,
      onClick: l[0] || (l[0] = (u) => t.$emit("click", u)),
      quaternary: e.quaternary,
      circle: e.circle,
      linkGray: e.linkGray
    }), {
      default: f(() => [
        n(t.$slots, "default"),
        a(o).icon ? n(t.$slots, "icon", { key: 0 }) : s("", !0)
      ]),
      _: 3
    }, 16, ["id", "text", "class", "type", "size", "disabled", "loading", "quaternary", "circle", "linkGray"]));
  }
}), q = k;
export {
  q as default
};
